import { cn } from "@reactive-resume/utils";

import { BrandMark } from "@/client/components/brand-mark";

type Props = {
  size?: number;
  className?: string;
};

export const Icon = ({ size = 32, className }: Props) => {
  return <BrandMark size={size} className={cn("text-black dark:text-white", className)} />;
};
